import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogComponent } from '../../../../shared/components/dialog/dialog.component';

@Component({
  selector: 'app-action-result-dialog',
  standalone: true,
  imports: [CommonModule, DialogComponent],
  templateUrl: './action-result-dialog.component.html',
})
export class ActionResultDialogComponent {
  @Input() show = false;
  @Input() fileNumber: string | null = null;
  @Input() agency: string | null = null;
  @Input() isError = false;
  @Input() action: string | null = null;
  @Input() showBack = false;
  @Input() size: 'sm' | 'md' | 'lg' | 'xl' | '2xl' = 'md';
  @Input() position: 'right' | 'center' = 'center';
  @Output() close = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  onClose() {
    this.close.emit();
  }

  onBack() {
    this.back.emit();
  }
}
